import { Directive, Input, OnChanges, SimpleChanges, TemplateRef, ViewContainerRef, inject } from '@angular/core';

@Directive({
  selector: '[nspVisible]',
  standalone: true,
})
export class IsVisibleDirective implements OnChanges {
  @Input() nspVisible = true;

  templateRef = inject(TemplateRef);
  viewContainerRef = inject(ViewContainerRef);

  ngOnChanges(changes: SimpleChanges) {
    if (changes['nspVisible']) {
      this.updateView();
    }
  }

  private updateView() {
    if (this.nspVisible) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainerRef.clear();
    }
  }
}
